const DEFAULT_CONFIG = {
	//标题
	APP_NAME: process.env.VUE_APP_TITLE,

	//首页地址
	DASHBOARD_URL: "/dashboard",

	//版本号
	APP_VER: "1.6.6",

	//内核版本号
	CORE_VER: "1.6.6",

	//接口地址
	API_URL: process.env.NODE_ENV === 'development' && process.env.VUE_APP_PROXY === 'true' ? "/api" : process.env.VUE_APP_API_BASEURL,

	//后端站点根地址（用于拼接插件管理等后端页面跳转地址；开发代理模式取env后端域名，生产未配置时取当前域名）
	BASE_HOST: process.env.NODE_ENV === 'development' && process.env.VUE_APP_PROXY === 'true' ? process.env.VUE_APP_API_BASEURL : (process.env.VUE_APP_API_BASEURL || window.location.origin),

	//商城H5端(Uniapp)预览地址基址：装修编辑器"预览"按钮用它拼接自定义页面路径（/pages/diy/diy?id=xx）
	//开发环境默认取后台同主机的 HBuilderX H5 默认端口(8080)；上线部署后请改为正式 H5 地址，如 https://saas.mingniukeji.net/app_front/bwmall
	H5_PREVIEW_BASE: process.env.NODE_ENV === 'development' ? `http://${window.location.hostname}:8080` : (process.env.VUE_APP_H5_BASEURL || window.location.origin),

	//请求超时
	TIMEOUT: 10000,

	//TokenName
	TOKEN_NAME: "Authorization",

	//Token前缀，注意最后有个空格，如不需要需设置空字符串
	TOKEN_PREFIX: "Bearer ",

	//追加其他头
	HEADERS: {
		'X-Requested-With':'XMLHttpRequest',
	},

	//请求是否开启缓存
	REQUEST_CACHE: false,

	//布局 默认：default | 通栏：header | 经典：menu | 功能坞：dock
	//dock将关闭标签和面包屑栏
	LAYOUT: 'default',

	//菜单是否折叠
	MENU_IS_COLLAPSE: false,

	//菜单是否启用手风琴效果
	MENU_UNIQUE_OPENED: false,

	//是否开启多标签
	LAYOUT_TAGS: true,

	//语言
	LANG: 'zh-cn',

	//主题颜色
	//COLOR: '#6e56ff',
	COLOR: '#4A5DFF',

	//Danger 颜色
	APP_COLOR_DANGER:'#f56c6c',

	//Success 颜色
	APP_COLOR_SUCCESS:'#67c23a',

	//是否加密localStorage, 为空不加密，可填写AES(模式ECB,移位Pkcs7)加密
	LS_ENCRYPTION: '',

	//localStorageAES加密秘钥，位数建议填写8的倍数
	LS_ENCRYPTION_key: '2XNN4K8LC0ELVWN4',

	//控制台首页默认布局
	DEFAULT_GRID: {
		//默认分栏数量和宽度 例如 [24] [18,6] [8,8,8] [6,12,6]
		layout: [12, 6, 6],
		//小组件分布，com取值:views/home/components 文件名
		copmsList: [
			['echarts','loginlog'],
			['topup', 'userlist','lesseenum'],
			['about','ver', 'time']
		]
	}
}

//合并业务配置
import MY_CONFIG from "./myConfig"
Object.assign(DEFAULT_CONFIG, MY_CONFIG)

// if(process.env.NODE_ENV === 'production'){
// 	Object.assign(DEFAULT_CONFIG, APP_CONFIG)
// }

export default DEFAULT_CONFIG
